import { useState, useCallback } from "react";

const useUniversalTipTap = ({
  editor,
  isEditable,
  editorClass,
  menubarClass,
  menubarPosition,
  linkModalClass,
  editorContainerClass,
  showTextActions = true,
  showBulletLists = true,
  showLink = true,
  showHeadingActions,
  onKeyDown,
}) => {
  const [linkState, setLinkState] = useState(null);

  const [textToDisplay, setTextToDisplay] = useState(null);
  const [showLinkModal, setShowLinkModal] = useState(false);

  const getSelectedText = () => {
    const { view, state } = editor || {};
    const { from, to } = view?.state?.selection || {};
    const currentSelection = state?.doc?.textBetween(from, to, "");
    return currentSelection;
  };

  const setLink = useCallback(
    (modalURL, textToDisplay) => {
      const previousUrl = editor.getAttributes("link").href;
      const url = modalURL?.trim() !== "" ? modalURL : "";
      const verifiedUrl = url.indexOf("://") === -1 ? "http://" + url : url;
      const whatToBeCalled =
        textToDisplay?.trim() !== "" ? textToDisplay : "Link";
      const { view, state } = editor;
      const { from, to } = view?.state?.selection;
      const currentSelection = state.doc.textBetween(from, to, "");
      // cancelled
      if (verifiedUrl === null) {
        return;
      }

      // empty
      if (verifiedUrl === "") {
        editor.chain().focus().unsetLink().run();

        return;
      }
      // update link
      if (previousUrl) {
        editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .setLink({ href: verifiedUrl })
          .run();
      } else {
        editor.commands.insertContent({
          type: "text",
          marks: [
            {
              type: "link",
              attrs: {
                href: verifiedUrl,
                class: null,
              },
            },
          ],
          text:
            whatToBeCalled ||
            (currentSelection?.trim() !== "" ? currentSelection : "Link"),
        });
        editor.chain().focus().unsetMark("link").run();
      }
      setShowLinkModal(false);
      setLinkState();
      setTextToDisplay();
    },
    [editor]
  );

  return {
    editor,
    isEditable,
    editorClass,
    menubarClass,
    menubarPosition,
    editorContainerClass,
    linkModalClass,
    getSelectedText,
    setLink,
    showLinkModal,
    setShowLinkModal,
    linkState,
    setLinkState,
    textToDisplay,
    setTextToDisplay,
    showTextActions,
    showBulletLists,
    showLink,
    showHeadingActions,
    onKeyDown,
  };
};

export default useUniversalTipTap;
